import { Fragment, type PropsWithChildren } from "react";

/**
 * React 19 natively hoists <title>, <meta>, <link>, and head <script> elements
 * rendered by route components into the document head. This compatibility
 * layer keeps the migrated page components unchanged while avoiding the
 * unsupported React 18-only react-helmet-async runtime in the SSR bundle.
 */
export function Helmet({ children }: PropsWithChildren) {
  return <Fragment>{children}</Fragment>;
}

export function HelmetProvider({ children }: PropsWithChildren) {
  return <Fragment>{children}</Fragment>;
}